import moment from 'moment';

// Ссылка-шаблон Google Calendar: открывает форму создания события в аккаунте
// пользователя с уже заполненными полями. Даты передаём в UTC (суффикс Z) —
// Google сам покажет их в часовом поясе пользователя.
const GOOGLE_CALENDAR_BASE_URL = 'https://calendar.google.com/calendar/render';

const toGoogleDate = (isoUtc) => moment.utc(isoUtc).format('YYYYMMDD[T]HHmmss[Z]');

export const buildGoogleCalendarUrl = ({
  title, startsAt, endsAt, details, location,
}) => {
  if (!startsAt || !endsAt) return '';

  const params = new URLSearchParams({ action: 'TEMPLATE', text: title || '' });
  if (details) params.set('details', details);
  if (location) params.set('location', location);

  // dates добавляем вручную: URLSearchParams закодировал бы разделитель «/» в %2F
  const dates = `${toGoogleDate(startsAt)}/${toGoogleDate(endsAt)}`;

  return `${GOOGLE_CALENDAR_BASE_URL}?${params.toString()}&dates=${dates}`;
};
